import React from 'react';
import { ApartmentCard } from './ApartmentCard.tsx';

export function RecommendedApartments({ apartments, apartmentImages, language, t, reccomend }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {reccomend && (
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[--c-dark] mb-4">

              {t.reccomendedTitle}
            </h2>
            <p className="text-[--c-main] text-xl md:text-2xl max-w-5xl mx-auto">
              {t.reccomendedDescription}
            </p>
          </div>
        )}

        <div className="flex flex-wrap justify-center lg:justify-between gap-12">
          {apartments && apartments
            .sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0))
            .map((apartment, index) => (
              <ApartmentCard
                key={index}
                {...apartment}
                language={language}
                t={t}
                name={apartment.name}
                ApartmentName={apartment.ApartmentName}
                apartmentImages={apartmentImages[apartment.ApartmentName]}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
